import { Star } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function StarRating({ rating = 4.9, count = 280, dark = false }) {
  const { t } = useLang();
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.5;
  const stars = Array.from({ length: 5 }, (_, i) => (i < full ? "full" : i === full && hasHalf ? "half" : "empty"));

  return (
    <div
      data-testid="google-review-rating"
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 ${
        dark ? "bg-white/10 text-white border border-white/15" : "bg-white border border-slate-200 shadow-sm"
      }`}
    >
      <div className="flex items-center" aria-label={`${rating} out of 5 stars`}>
        {stars.map((s, i) => (
          <Star
            key={i}
            size={16}
            className={s === "empty" ? (dark ? "text-white/30" : "text-slate-300") : "text-amber-400"}
            fill={s === "empty" ? "none" : "currentColor"}
          />
        ))}
      </div>
      <span className={`text-sm font-semibold ${dark ? "text-white" : "text-slate-900"}`}>
        {rating.toFixed(1)}
      </span>
      <span className={`text-xs ${dark ? "text-white/70" : "text-slate-500"}`}>
        ({count}+ {t.common.googleRating})
      </span>
    </div>
  );
}
